// Generated from Kenno's OpenAPI
import { z } from 'zod';

export enum KennoNotificationCategory {
  ARREAR = 'arrear',
  CONTRACT_LIFECYCLE = 'contract_lifecycle',
  CONTRACT_TERMINATION_REQUEST_APPROVAL_NEEDED = 'contract_termination_request_approval_needed',
  CONTRACT_TERMINATION_REQUEST_CREATED = 'contract_termination_request_created',
  CONTRACT_TERMINATION_REQUEST_KENNO_ACCEPTED = 'contract_termination_request_kenno_accepted',
  CONTRACT_TERMINATION_REQUEST_KENNO_REJECTED = 'contract_termination_request_kenno_rejected',
  CONTRACT_TERMINATION_REQUEST_TENANT_ACCEPTED = 'contract_termination_request_tenant_accepted',
  CONTRACT_TERMINATION_REQUEST_TENANT_REJECTED = 'contract_termination_request_tenant_rejected',
  NORMAL = 'normal',
}

const NotificationMetaSchema = z.union([
  z.null(),
  z.object({
    arrearAmount: z.string(),
  }),
]);

export const kennoNotificationSchema = z.object({
  contractUuid: z.string().uuid(),
  id: z.number(),
  priority: z.enum(['important', 'normal']),
  category: z.nativeEnum(KennoNotificationCategory),
  notificationMeta: NotificationMetaSchema,
  isCloseable: z.boolean(),
  createdAt: z.string(), // Timezone offsets are not supported by Zod, mark dates as strings instead
  closedAt: z.union([z.string(), z.null()]).default(null),
});

export type KennoNotification = z.infer<typeof kennoNotificationSchema>;
